import React from "react";
import ReactDOM from "react-dom/client";
import "src/index.css";
import App from "src/App";
import { ViewProvider } from "src/contexts/ViewContext";
import { ConfigurationProvider } from "src/contexts/ConfigurationContext";
import { LoaderProvider } from "src/contexts/LoaderContext";
import { PopupProvider } from "src/contexts/PopupContext";

const rootElement = document.getElementById("configurator-container");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement as HTMLElement);
  root.render(
    <React.StrictMode>
      <LoaderProvider>
        <PopupProvider>
          <ViewProvider>
            <ConfigurationProvider>
              <App />
            </ConfigurationProvider>
          </ViewProvider>
        </PopupProvider>
      </LoaderProvider>
    </React.StrictMode>,
  );
} else {
  console.error("Element with id 'configurator-container' not found.");
}
